export type ViewType = 'day' | 'week';

export type PageQueryParams = {
  view: ViewType;
  date: Date;
  schedulerId: string | null;
};

export const VIEW_PARAM = 'view';
export const DATE_PARAM = 'date';
export const SCHEDULER_PARAM = 'scheduler';
export const VIEW_DAY = 'day';
export const VIEW_WEEK = 'week';
